import { styled } from '@mui/material/styles';

export const DatePickerWrapper = styled('div')(({ theme }) => ({
  position: 'relative',
  '.react-datepicker-wrapper': {
    width: '100%'
  },
  '.react-datepicker-popper': {
    zIndex: 9999,
    position: 'fixed !important',
    transform: 'none !important',
    marginTop: '8px !important',
    width: '700px',
    left: '-400px !important',
  },
  '.react-datepicker': {
    fontSize: '0.9rem',
    display: 'flex !important',
    border: '1px solid #e0e0e0',
    borderRadius: '4px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    backgroundColor: 'white',
    '.react-datepicker__month-container': {
      float: 'none !important',
      width: '350px',
      padding: '16px',
      '& + .react-datepicker__month-container': {
        borderLeft: '1px solid #e0e0e0',
      }
    },
    '.react-datepicker__header': {
      backgroundColor: 'white',
      borderBottom: 'none',
      padding: 0,
    },
    '.react-datepicker__current-month': {
      fontSize: '1.1rem',
      color: '#000',
      marginBottom: '10px',
    },
    '.react-datepicker__month': {
      margin: '8px 0 0',
      padding: '0',
    },
    '.react-datepicker__week': {
      margin: '2px 0',
      height: '40px',
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center',
    },
    '.react-datepicker__day-names, .react-datepicker__week': {
      display: 'flex',
      justifyContent: 'space-around',
      width: '100%',
    },
    '.react-datepicker__day-name': {
      color: '#666',
      width: '40px',
      lineHeight: '40px',
      margin: '0',
      fontSize: '0.9rem',
    },
    '.react-datepicker__day': {
      width: '40px',
      height: '40px',
      lineHeight: '40px',
      margin: '0',
      padding: '0',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#333',
      transition: 'all 0.2s ease',
      outline: 'none',
      '&:hover': {
        backgroundColor: '#e3f2fd',
        borderRadius: '50%',
      },
      '&:active, &:focus': {
        backgroundColor: '#1976d2',
        color: 'white',
        borderRadius: '50%',
      }
    },
    '.react-datepicker__day--selected, .react-datepicker__day--range-start, .react-datepicker__day--range-end': {
      backgroundColor: '#1976d2',
      color: 'white',
      borderRadius: '50%',
      '&:hover': {
        backgroundColor: '#1565c0',
        borderRadius: '50%',
      },
      '&:active, &:focus': {
        backgroundColor: '#0d47a1',
      }
    },
    '.react-datepicker__day--in-range': {
      backgroundColor: '#bbdefb',
      color: '#000',
      borderRadius: '50%',
      '&:hover': {
        backgroundColor: '#90caf9',
        borderRadius: '50%',
      },
      '&:active, &:focus': {
        backgroundColor: '#1976d2',
        color: 'white',
        borderRadius: '50%',
      }
    },
    '.react-datepicker__day--in-selecting-range': {
      backgroundColor: '#bbdefb',
      color: '#000',
      borderRadius: '50%',
      '&:hover': {
        backgroundColor: '#90caf9',
      }
    },
    '.react-datepicker__day--keyboard-selected': {
      backgroundColor: 'transparent',
      color: '#333',
      '&:hover': {
        backgroundColor: '#e3f2fd',
      }
    },
    '.react-datepicker__day--range-start.react-datepicker__day--range-end': {
      backgroundColor: '#1976d2',
      color: 'white',
      borderRadius: '50%',
    },
    '.react-datepicker__day--range-start': {
      backgroundColor: '#1976d2',
      color: 'white',
      borderRadius: '50%',
    },
    '.react-datepicker__day--range-end': {
      backgroundColor: '#1976d2',
      color: 'white',
      borderRadius: '50%',
    },
    '.react-datepicker__day--outside-month': {
      color: 'rgba(51, 51, 51, 0.3) !important',
      visibility: 'visible !important',
      display: 'block !important',
      pointerEvents: 'auto !important',
      '&:hover': {
        backgroundColor: '#e3f2fd',
        borderRadius: '50%',
      },
      '&:active, &:focus': {
        backgroundColor: '#1976d2',
        color: 'white',
        borderRadius: '50%',
      }
    },
    '.react-datepicker__day--in-range.react-datepicker__day--outside-month': {
      backgroundColor: 'rgba(187, 222, 251, 0.3)',
      color: 'rgba(0, 0, 0, 0.3)',
      borderRadius: '50%',
      visibility: 'visible !important',
      display: 'block !important',
      '&:hover': {
        backgroundColor: 'rgba(144, 202, 249, 0.3)',
        borderRadius: '50%',
      }
    },
    '.react-datepicker__day--range-start.react-datepicker__day--outside-month, .react-datepicker__day--range-end.react-datepicker__day--outside-month': {
      backgroundColor: 'rgba(25, 118, 210, 0.3)',
      color: 'white',
      borderRadius: '50%',
      visibility: 'visible !important',
      display: 'block !important',
      '&:hover': {
        backgroundColor: 'rgba(21, 101, 192, 0.3)',
        borderRadius: '50%',
      }
    },
    '.react-datepicker__day--today': {
      backgroundColor: '#333',
      color: 'white',
      borderRadius: '50%',
      fontWeight: 'normal',
      '&:hover': {
        backgroundColor: '#444',
      },
      '&:active, &:focus': {
        backgroundColor: '#222',
      },
      '&.react-datepicker__day--in-range': {
        backgroundColor: '#333',
        color: 'white',
      },
      '&.react-datepicker__day--range-start, &.react-datepicker__day--range-end': {
        backgroundColor: '#1976d2',
        color: 'white',
      },
      '&.react-datepicker__day--outside-month': {
        backgroundColor: 'rgba(51, 51, 51, 0.3)',
        color: 'white',
      }
    }
  },
  '.react-datepicker__tab-loop': {
    position: 'fixed',
    zIndex: 9999,
    '& .react-datepicker-popper': {
      position: 'absolute !important',
      transform: 'none !important'
    }
  },

  // 모바일 대응
  [theme.breakpoints.down('sm')]: {
    '.react-datepicker-popper': {
      width: '366px !important',
      position: 'absolute !important',
      left: '50% !important',
      transform: 'translateX(-50%) !important',
      top: '40px !important',
    },
    '.react-datepicker': {
      width: '100%',
      '.react-datepicker__month-container': {
        width: '366px',
        float: 'none',
        padding: '8px',
      }
    }
  }
}));

export default DatePickerWrapper; 